import Table from "../UI/Table";
import AnalyticsPagination from "./AnalyticsPagination";
import PageSizeSelector from "../PageSizeSelector";

const AnalyticsTable = ({
    columns,
    data,
    currentPage,
    totalPages,
    totalCount,
    pageSize,
    onPageSizeChange,
    onPageChange,
    onRowClick,
}) => {
    return (
        <div className="space-y-3">
            <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
                <Table columns={columns} data={data} onRowClick={onRowClick} />
            </div>
            <AnalyticsPagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalCount={totalCount}
                pageSize={pageSize}
                onPageSizeChange={onPageSizeChange}
                onPageChange={onPageChange}
            />
        </div>
    );
};

export default AnalyticsTable;